/* CUERA · Lote 01 — interacción mínima de la capa premium.
   El carrito lo sigue llevando cuera-motion.js ([data-add], [data-bag-btn]).
   Aquí sólo: menú móvil, contador de la galería y barra fija de compra.
   Script clásico, sin módulos (ver nota en cuera-motion.js). */
(function () {
  'use strict';

  /* Menú móvil: función global, sobrevive a cualquier repintado de sección. */
  window.ltMenu = function (btn) {
    var menu = document.getElementById('lt-menu');
    if (!menu) return false;
    var abierto = menu.classList.toggle('is-abierto');
    if (btn) btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    return false;
  };

  /* Pausa/reproduce el video de la portada (accesibilidad: todo video que se
     mueve solo necesita poder pararse). */
  window.ltPausa = function (btn) {
    var v = btn && btn.parentNode && btn.parentNode.querySelector('video');
    if (!v) return false;
    if (v.paused) { v.play(); btn.setAttribute('aria-label', 'Pausar video'); btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><rect x="3" y="2" width="2.4" height="10" fill="currentColor"/><rect x="8.6" y="2" width="2.4" height="10" fill="currentColor"/></svg>'; }
    else { v.pause(); btn.setAttribute('aria-label', 'Reproducir video'); btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><path d="M4 2l8 5-8 5z" fill="currentColor"/></svg>'; }
    return false;
  };

  function contadorGaleria() {
    document.querySelectorAll('[data-lt-galeria]').forEach(function (g) {
      var caja = g.parentNode.querySelector('[data-lt-contador]');
      if (!caja || g.__lt) return;
      g.__lt = true;
      var total = g.children.length;
      var pintar = function () {
        var i = Math.round(g.scrollLeft / Math.max(1, g.clientWidth)) + 1;
        caja.textContent = Math.min(i, total) + ' / ' + total;
      };
      var minis = g.parentNode.querySelector('[data-lt-minis]');
      var botones = minis ? Array.prototype.slice.call(minis.children) : [];
      var marcar = function () {
        if (!botones.length) return;
        var w = g.children[0] ? g.children[0].offsetWidth + 4 : g.clientWidth;
        var i = Math.round(g.scrollLeft / Math.max(1, w));
        botones.forEach(function (b, k) { b.classList.toggle('is-activa', k === i); });
        var act = botones[i];
        if (act && minis.scrollTo) minis.scrollTo({ left: act.offsetLeft - 16, behavior: 'smooth' });
      };
      botones.forEach(function (b, k) {
        b.addEventListener('click', function () {
          var it = g.children[k];
          if (it) g.scrollTo({ left: it.offsetLeft, behavior: 'smooth' });
        });
      });
      g.addEventListener('scroll', function () { pintar(); marcar(); }, { passive: true });
      pintar(); marcar();
    });
  }

  /* Barra fija (Hyer): visible siempre que el botón real NO esté en pantalla
     (por debajo del doblez al cargar, o ya pasado) y ningún otro botón de
     compra esté a la vista. Nunca dos botones de compra a la vez. */
  function barra() {
    var b = document.querySelector('[data-lt-barra]');
    var cta = document.querySelector('[data-lt-cta]');
    if (!b || !cta) return;
    var otros = Array.prototype.slice.call(document.querySelectorAll('[data-lt-cta-extra]'));
    var tick = false;
    var revisar = function () {
      tick = false;
      var vh = window.innerHeight;
      var r = cta.getBoundingClientRect();
      var salio = !(r.top < vh && r.bottom > 0);   // fuera de vista, arriba o abajo
      var tapado = otros.some(function (o) {
        var q = o.getBoundingClientRect();
        return q.top < vh && q.bottom > 0;
      });
      b.classList.toggle('is-visible', salio && !tapado);
      b.setAttribute('aria-hidden', salio && !tapado ? 'false' : 'true');
    };
    var pedir = function () { if (!tick) { tick = true; requestAnimationFrame(revisar); } };
    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    revisar();
  }

  /* Portada a la Polène: el encabezado flota transparente sobre la foto y se
     vuelve blanco en cuanto se baja (o se abre el menú). */
  function encabezado() {
    var h = document.querySelector('[data-lt-head].lt-head--sobre');
    if (!h || h.__lt) return;
    h.__lt = true;
    var pintar = function () {
      var menu = document.getElementById('lt-menu');
      var abierto = menu && menu.classList.contains('is-abierto');
      h.classList.toggle('is-solida', window.scrollY > 24 || abierto);
    };
    window.addEventListener('scroll', pintar, { passive: true });
    document.addEventListener('click', function () { setTimeout(pintar, 0); });
    pintar();
  }

  function videos() {
    var vs = document.querySelectorAll('[data-lt-videos] video');
    if (!vs.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { if (v.preload === 'none') { v.preload = 'auto'; } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.5 });
    vs.forEach(function (v) { io.observe(v); });
  }

  function desfile() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.lt-vid__ventana').forEach(function (w) {
      if (w.__lt) return; w.__lt = true;
      var pista = w.querySelector('.lt-vid__pista'); if (!pista) return;
      var pausa = 0, pos = w.scrollLeft, visible = false;
      var parar = function () { pausa = Date.now() + 2500; };
      ['pointerdown', 'touchstart', 'wheel', 'mouseenter'].forEach(function (e) { w.addEventListener(e, parar, { passive: true }); });
      w.addEventListener('mouseleave', function () { pausa = 0; });
      w.addEventListener('scroll', function () { if (Date.now() < pausa) pos = w.scrollLeft; }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }).observe(w); else visible = true;
      (function paso() {
        if (visible && Date.now() >= pausa) {
          var mitad = pista.scrollWidth / 2;
          pos += 0.6; if (pos >= mitad) pos -= mitad;
          w.scrollLeft = pos;
        } else if (Date.now() < pausa) { var m = pista.scrollWidth / 2; if (w.scrollLeft >= m) { w.scrollLeft -= m; } pos = w.scrollLeft; }
        requestAnimationFrame(paso);
      })();
    });
  }

  /* Pósters de los videos: se piden al acercarse a la sección, no al cargar
     (eran 15 imágenes compitiendo con la foto principal en 4G). */
  function posters() {
    var vs = document.querySelectorAll('[data-lt-videos] video[data-poster]');
    if (!vs.length) return;
    var poner = function (v) { if (!v.poster) v.poster = v.getAttribute('data-poster'); };
    if (!('IntersectionObserver' in window)) { vs.forEach(poner); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { poner(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '900px 900px' });
    vs.forEach(function (v) { io.observe(v); });
  }

  /* 26-oct · Visor de fotos: tocar una foto de [data-lt-visor] la abre a
     pantalla completa; tocar otra vez acerca (2.5x) donde tocaste.
     Delegado en document: sobrevive a repintados de sección. */
  var visor = null;
  function grande(img) {
    var mejor = img.currentSrc || img.src, ancho = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (p) {
      var m = p.trim().split(/\s+/), w = parseInt(m[1], 10);
      if (m[0] && w > ancho) { ancho = w; mejor = m[0]; }
    });
    return mejor;
  }
  function bloquear(si) {
    var hoja = document.getElementById('lt-regalo-hoja');
    var otro = hoja && !hoja.hidden;
    var vis = visor && !visor.hidden;
    document.documentElement.classList.toggle('lt-sin-scroll', !!(si || otro || vis));
  }
  function contarVisor() {
    var pista = visor.querySelector('.lt-visor__pista');
    var n = pista.children.length;
    var i = Math.round(pista.scrollLeft / Math.max(1, pista.clientWidth)) + 1;
    visor.querySelector('.lt-visor__n').textContent = Math.min(i, n) + ' / ' + n;
  }
  function cerrarVisor() {
    if (!visor || visor.hidden) return;
    visor.hidden = true;
    visor.querySelector('.lt-visor__pista').innerHTML = '';
    bloquear(false);
    if (visor.__desde && visor.__desde.focus) visor.__desde.focus();
  }
  function armarVisor() {
    if (visor) return visor;
    visor = document.createElement('div');
    visor.className = 'lt-visor';
    visor.setAttribute('role', 'dialog');
    visor.setAttribute('aria-modal', 'true');
    visor.setAttribute('aria-label', 'Fotos en grande');
    visor.hidden = true;
    visor.innerHTML = '<div class="lt-visor__cab"><span class="lt-visor__n" aria-live="polite"></span><button type="button" class="lt-visor__x" aria-label="Cerrar">&#10005;</button></div><div class="lt-visor__pista"></div><div class="lt-visor__ayuda">Toca para acercar · desliza para ver la siguiente</div>';
    document.body.appendChild(visor);
    visor.querySelector('.lt-visor__x').addEventListener('click', cerrarVisor);
    var pista = visor.querySelector('.lt-visor__pista');
    pista.addEventListener('scroll', contarVisor, { passive: true });
    pista.addEventListener('click', function (e) {
      var f = e.target.closest('.lt-visor__foto'); if (!f) return;
      var img = f.querySelector('img'); if (!img) return;
      if (f.classList.contains('is-zoom')) { f.classList.remove('is-zoom'); f.scrollLeft = 0; f.scrollTop = 0; return; }
      var r = img.getBoundingClientRect();
      var fx = (e.clientX - r.left) / Math.max(1, r.width), fy = (e.clientY - r.top) / Math.max(1, r.height);
      f.classList.add('is-zoom');
      requestAnimationFrame(function () {
        f.scrollLeft = img.offsetWidth * fx - f.clientWidth / 2;
        f.scrollTop = img.offsetHeight * fy - f.clientHeight / 2;
      });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && visor && !visor.hidden) cerrarVisor(); });
    return visor;
  }
  function abrirVisor(imgs, k, desde) {
    armarVisor();
    var pista = visor.querySelector('.lt-visor__pista');
    pista.innerHTML = '';
    imgs.forEach(function (im, i) {
      var f = document.createElement('div'); f.className = 'lt-visor__foto';
      var g = document.createElement('img');
      g.src = grande(im); g.alt = im.alt || ''; g.decoding = 'async';
      if (Math.abs(i - k) > 1) g.loading = 'lazy';
      f.appendChild(g); pista.appendChild(f);
    });
    visor.__desde = desde;
    visor.hidden = false;
    bloquear(true);
    requestAnimationFrame(function () { pista.scrollLeft = k * pista.clientWidth; contarVisor(); });
    visor.querySelector('.lt-visor__x').focus();
  }
  document.addEventListener('click', function (e) {
    var cont = e.target.closest('[data-lt-visor]'); if (!cont) return;
    var img = e.target.tagName === 'IMG' ? e.target : null;
    if (!img) { var it = e.target.closest('figure,button'); img = it && cont.contains(it) ? it.querySelector('img') : null; }
    if (!img) return;
    var imgs = Array.prototype.slice.call(cont.querySelectorAll('img')).filter(function (im) { return !im.closest('video'); });
    var k = imgs.indexOf(img); if (k < 0) return;
    e.preventDefault();
    abrirVisor(imgs, k, e.target.closest('button') || img);
  });

  /* 26-oct · Hoja del regalo (cosmetiquera). Función global: onclick en el HTML. */
  window.ltRegalo = function (abrir) {
    var h = document.getElementById('lt-regalo-hoja');
    if (!h) return false;
    if (abrir) {
      h.hidden = false; bloquear(true);
      requestAnimationFrame(function () { h.classList.add('is-abierta'); });
      var x = h.querySelector('.lt-hoja__x'); if (x) x.focus();
    } else {
      h.classList.remove('is-abierta');
      setTimeout(function () { h.hidden = true; bloquear(false); }, 250);
    }
    return false;
  };
  document.addEventListener('keydown', function (e) {
    var h = document.getElementById('lt-regalo-hoja');
    if (e.key === 'Escape' && h && !h.hidden && !(visor && !visor.hidden)) window.ltRegalo(false);
  });

  /* Menú: al tocar un enlace (también un #ancla de la misma página) se cierra. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#lt-menu a'); if (!a) return;
    var menu = document.getElementById('lt-menu');
    if (menu) menu.classList.remove('is-abierto');
    var b = document.querySelector('[aria-controls="lt-menu"]');
    if (b) b.setAttribute('aria-expanded', 'false');
  });

  function init() { contadorGaleria(); barra(); encabezado(); posters(); videos(); desfile(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

